/*
* Display available lookup tables
*/

import '../common/bootstrap/bootstrapcolxl.css';

import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import * as ReduxQueries from '../queries';

export interface ILookupTablesProps extends AppComp.IAppComponentProps {
    regionDetailRegion?: any;
    regionId?: any;
    users?: any;
    offices?: any;
    updateRegion?: any;
    navigateTo?: any;
}

export interface ILookupTablesState extends AppComp.IAppComponentState {
    formChanges?: any;
}

class LookupTables extends AppComp.AppComponent<ILookupTablesProps, ILookupTablesState> {
    public originalFormDataCache = {};
    public kendoFormWhiteBoxSectionProps = {};

    public constructor(props: ILookupTablesProps) {
        super(props, 'app.lookup-tables.');

        this.state = {
            formChanges: {},
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();

        if (resetFormData && _.size(this.state.formChanges)) {
            this.setState({ formChanges: {} });
        }
    }

    // Handlers
    public handleEditLookupTableButtonClick(e: any, o: any) {
        // console.log('handleEditLookupTableButtonClick', { e: e, o: o });

        const lookupLink = Formatters.getStr(o, 'lookupLink');
        switch (lookupLink) {
            // case (LK.LookupKeys.Regions): {
            //     this.props.navigateTo(NavigationLinks.defaultManagers());
            //     break;
            // }

            default: {
                this.props.navigateTo(NavigationLinks.lookupTableEdit(Formatters.getStr(o, 'lookupLink')));
                break;
            }
        }
    }

    public handleSaveButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { region: _.pick(this.props.regionDetailRegion, ['regionId', '_id']) },
            this.state.formChanges
        );

        // console.log('handleSaveButton changeData', changeData);

        this.props.updateRegion(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                this.setState({ formChanges: {} });
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        const getChangesResult = this.getFormChanges(e, x);
        // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        if (getChangesResult.applyChanges) {
            this.setState({
                formChanges: getChangesResult.formChanges
            });
        }
    }

    public handleFormOfficeCheckboxChange(e: any, x: any) {
        const officeObjId = Formatters.getStr(e, 'target.props.name');
        const officeNewAssigned = _.get(e, 'value') ? true : false;

        const { regionDetailRegion, regionId, users, offices, ...rest } = this.props;

        const formData = this.getFormData(regionDetailRegion, regionId, users, offices);

        let filteredOfficesAdd = _.reject(_.cloneDeep(_.get(formData, 'officesAdd', [])), (o) => {
            const match = (String(o) === String(officeObjId)) ? true : false;
            return match;
        });
        let filteredOfficesDelete = _.reject(_.cloneDeep(_.get(formData, 'officesDelete', [])), (o) => {
            const match = (String(o) === String(officeObjId)) ? true : false;
            return match;
        });

        let regionOfficesChanges = _.stubArray();
        if (!officeNewAssigned) {
            filteredOfficesDelete.push(officeObjId);
            regionOfficesChanges.push({ fieldName: 'officesAdd', newValue: _.cloneDeep(filteredOfficesAdd) });
            regionOfficesChanges.push({ fieldName: 'officesDelete', newValue: _.cloneDeep(filteredOfficesDelete) });
        } else {
            filteredOfficesAdd.push(officeObjId);
            regionOfficesChanges.push({ fieldName: 'officesAdd', newValue: _.cloneDeep(filteredOfficesAdd) });
            regionOfficesChanges.push({ fieldName: 'officesDelete', newValue: _.cloneDeep(filteredOfficesDelete) });
        }

        if (_.size(regionOfficesChanges)) {
            let cloneFormChanges = _.cloneDeep(this.state.formChanges);

            regionOfficesChanges.forEach((o) => {
                _.set(cloneFormChanges, o.fieldName, _.cloneDeep(o.newValue));
            });

            this.setState({ formChanges: cloneFormChanges });
        }
    }

    // Helpers
    public getFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.formChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);
        let formChangesResult = {};
        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public getFormData(regionIn: any, regionId: any, users: any, offices: any) {
        const region = _.merge({}, regionIn, this.state.formChanges);

        const regionDefaultManagerUserOptions = (_.size(users)) ?
            users.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.composeUsernameLabel(c, true) }))
            : [];

        const regionSiteInspectorUserOptions = (_.size(users)) ?
            users.map((c) => _.merge({}, { value: Formatters.getStr(c, '_id'), text: Formatters.composeUsernameLabel(c, true) }))
            : [];

        const regionOfficeOptions = (_.size(offices)) ?
            offices.map((c) => _.merge({}, {
                value: Formatters.getStr(c, '_id'),
                text: Formatters.getStr(c, 'name'),
                assigned: false,
                location: _.get(c, 'location'),
            })) : [];

        const regionOffices = _.filter(offices, (o) => {
            const oReg = _.get(o, 'regions', []);
            const oRegIds = _.map(oReg, (p) => String(p._id));

            return _.includes(oRegIds, String(region._id));
        });

        let result = {
            regionId: Formatters.getInt(region, 'regionId'),

            defaultManager: _.get(region, 'defaultManager'),
            defaultSiteInspector: _.get(region, 'defaultSiteInspector'),
            description: Formatters.getStr(region, 'description'),
            name: Formatters.getStr(region, 'name'),
            regionOffices: regionOffices,
            offices: offices,

            officesExisting: _.map(regionOffices, '_id'),
            officesAdd: _.get(region, 'officesAdd', []),
            officesDelete: _.get(region, 'officesDelete', []),

            regionDefaultManagerUserOptions: (_.size(regionDefaultManagerUserOptions)) ? regionDefaultManagerUserOptions : [],
            regionSiteInspectorUserOptions: (_.size(regionSiteInspectorUserOptions)) ? regionSiteInspectorUserOptions : [],
            regionOfficeOptions: (_.size(regionOfficeOptions)) ? regionOfficeOptions : [],
        };

        if ((_.size(result.officesExisting) || _.size(result.officesAdd) || _.size(result.officesDelete)) && _.size(result.regionOfficeOptions)) {
            _.forEach(result.regionOfficeOptions, (o) => {
                const officeObjId = Formatters.getStr(o, 'value');

                const isExisting = (_.includes(result.officesExisting, officeObjId)) ? true : false;
                const isAdded = (_.includes(result.officesAdd, officeObjId)) ? true : false;
                const isDeleted = (_.includes(result.officesDelete, officeObjId)) ? true : false;

                const isAssigned = ((isExisting || isAdded) && !isDeleted) ? true : false;

                if (o.assigned !== isAssigned) {
                    _.set(o, 'assigned', isAssigned);
                }
            });
        }

        return _.merge({}, result, this.state.formChanges);
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'regionId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'regionId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    // Renderers
    public renderLookupTables(formData: any) {
        let lookupTables = _(formData.lookupTables)
            .orderBy(['name'], ['asc'])
            .map((c) => {
                return (
                    <div className="lookup-tables-table-container" key={`lookup-tables-table-container-${c.name}`}>
                        <div className="lookup-tables-table-wrapper">
                            <div>
                                <div className="lookup-tables-table-name">
                                    <i className="fa fa-cogs lookup-tables-table-name-glyph" aria-hidden="true" /> {c.name}
                                </div>
                                <hr className="lookup-tables-hr" />
                            </div>
                            <div className="lookup-tables-table-description">
                                {Formatters.getStr(c, 'description')}
                            </div>
                            <Row>
                                <Col xs={2}><div /></Col>
                                <Col xs={8}>
                                    <div className="lookup-tables-table-button text-center">
                                        <Button block={true} bsStyle="info" onClick={(e) => { this.handleEditLookupTableButtonClick(e, c); }}>
                                            <i className="fa fa-database" aria-hidden="true" /> {this.appText('configure')}
                                        </Button>
                                    </div>
                                </Col>
                                <Col xs={2}><div /></Col>
                            </Row>
                        </div>
                    </div>
                );
            })
            .value();

        return (
            <WhiteBoxPageSection {...this.kendoFormWhiteBoxSectionProps} title={this.appText('system-configuration')}>
                {lookupTables}
            </WhiteBoxPageSection>
        );
    }

    public render() {
        const pageTitle = this.appTextPageTitle('page-title', true);
        const lookupTableTextContextPrefix: string = 'tables.textContents.';

        const buildLookupTableObj = (nameAppTextPath: string, descriptionAppTextPath: string, lookupLink: string) => {
            let result = _.merge({}, {
                name: this.appText(nameAppTextPath),
                description: this.appText(descriptionAppTextPath),
                lookupLink: lookupLink,
            });

            return result;
        };

        const composeTableAppTextPath = (appTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = '') => {
            let result = _.join([appTextPathPrefix, appTextPath, appTextPathSuffix], '.');
            return result;
        };

        const composeNameAppTextPath = (nameAppTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = 'table-title') => {
            let result = composeTableAppTextPath(nameAppTextPath, appTextPathPrefix, appTextPathSuffix);
            return result;
        };

        const composeDescAppTextPath = (descAppTextPath: string, appTextPathPrefix: string = 'tables', appTextPathSuffix: string = 'table-description') => {
            let result = composeTableAppTextPath(descAppTextPath, appTextPathPrefix, appTextPathSuffix);
            return result;
        };

        const buildLookupTableConfig = (name: string, lookupKey: string) => {
            let result = buildLookupTableObj(composeNameAppTextPath(name), composeDescAppTextPath(name), lookupKey);
            return result;
        };

        const formData = {
            lookupTables: [
                buildLookupTableConfig('textContents', LK.LookupKeys.TextContents),
                buildLookupTableConfig('associationTypes', LK.LookupKeys.AssociationTypes),
                buildLookupTableConfig('clientTypes', LK.LookupKeys.ClientTypes),
                buildLookupTableConfig('roofTypes', LK.LookupKeys.RoofTypes),
                buildLookupTableConfig('fencingTypes', LK.LookupKeys.FencingTypes),
                buildLookupTableConfig('sidingTypes', LK.LookupKeys.SidingTypes),
                buildLookupTableConfig('securedTypes', LK.LookupKeys.SecuredTypes),
                buildLookupTableConfig('recRoomTypes', LK.LookupKeys.RecRoomTypes),
                buildLookupTableConfig('componentCategories', LK.LookupKeys.ComponentCategories),
                buildLookupTableConfig('componentLocations', LK.LookupKeys.ComponentLocations),
                buildLookupTableConfig('components', LK.LookupKeys.Components),
                // buildLookupTableConfig('inventoryTemplates', composeDescAppTextPath('inventoryTemplates', LK.LookupKeys.InventoryTemplates),
                buildLookupTableConfig('regions', LK.LookupKeys.Regions),
                buildLookupTableConfig('replacementCostTypes', LK.LookupKeys.ReplacementCostTypes),
                buildLookupTableConfig('userResumes', LK.LookupKeys.UserResumes),
                buildLookupTableConfig('serviceLevels', LK.LookupKeys.ServiceLevels),
                buildLookupTableConfig('groupComponentsStandardEvaluations', LK.LookupKeys.GroupComponentsStandardEvaluations),
                buildLookupTableConfig('statusLevels', LK.LookupKeys.StatusLevels),
                buildLookupTableConfig('replacementCosts', LK.LookupKeys.ReplacementCosts),
            ],
        };

        const page = (
            <div className="lookup-tables-page-container">
                {this.renderLookupTables(formData)}
            </div>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...this.props}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = props => ApiEndpoints.getEditRegionUrl(props.match.params.regionId);

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getEditRegionDetailRequest(
    getApiUrl(props),
    ReduxQueries.PropsAccessToken(props),
);

const mapStateToProps = (state, props) => {
    const regionId = _.get(props, 'match.params.regionId', 0);

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        regionId: regionId,
        regionDetailRegion: state.entities.editRegionDetailRegion,
        regionDetailRegionOffices: state.entities.editRegionDetailRegionOffices,
        users: state.entities.editRegionDetailUsers,
        offices: state.entities.editRegionDetailOffices,
    });
};

const mapDispatchToProps = {
    updateRegion: MutateActions.updateRegionMutateAsync,
    navigateTo: (path) => push(path),
};

const LookupTablesContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(LookupTables);

export default withRouter(LookupTablesContainer);



// WEBPACK FOOTER //
// ./src/lookup-tables/index.tsx